/* eslint-disable */
import { Middleware } from "@sa/rep-common";
import { DataFlowProcessingState } from "@sa/rep-core";
import { DictionariesService } from "@sa/rep-mdm";
import { ServiceProvider } from "@sa/rep-services-provider";
import { ServicesRegister } from "../../../shared";
import { REPORT_ID, REPORT_APE_ID } from '../constants';

export const report6DataflowMiddlewares = (serviceProvider: ServiceProvider) => {
  const lastYearsCommodities = new Map<number, number>();
  const reportParameters = new Map<string, unknown>();
  const dictionariesServices = serviceProvider.resolve<DictionariesService>(ServicesRegister.Dictionary);
  return (async (input, next) => {
    if ([REPORT_APE_ID, REPORT_ID].includes(input.reportId)) {
      const parameters = input.parameters as Map<string, unknown>;
      if (parameters.has("@commodities")) {
        const commodities = parameters.get("@commodities") as number[];
        let lastYear: number;
        if (!lastYearsCommodities.has(commodities[0])) {
          const attributes = [30, 100];
          const countries = [];
          const units = [];

          const dictionary = await dictionariesServices.getDictionary({
            id: 'slides-f-last-calendar',
            parameters: {
              attributes: attributes.join(','),
              countries: countries.join(','),
              commodities: commodities.join(','),
              units: units.join(','),
              slide: 26,
            }
          });
          const items = await dictionary.getAll();
          const year = new Date().getFullYear();
          lastYear = Number(`1${year}0101`);

          const candidate = items.length ? Number(items[0].id) : null;
          if (candidate) {
            lastYear = candidate;
          }

          lastYearsCommodities.set(commodities[0], lastYear);
        } else {
          lastYear = lastYearsCommodities.get(commodities[0])!;
        }
        parameters.set("@last_year", lastYear);
        parameters.set("@calendar", [lastYear]);
      }

      for (const key of parameters.keys()) {
        reportParameters.set(key, parameters.get(key))
      }
    }
    return next(input);
  }) as Middleware<DataFlowProcessingState>
};  
